import { useBodySize } from '@hook/windowSize'
import { BREAKPOINTS } from '@constants/common'
import React from 'react'
import { MiniOfferPopup } from './MiniOfferPopup'

export const InformationRequests: React.FC = () => {
  const winSize = useBodySize()
  return <>{winSize?.width > BREAKPOINTS.laptop && <MiniOfferPopup />}</>
}
